/**
 * Keys of cookies we are manually setting for the application.
 */
export enum ApplicationSetCookies {
    OktaSub = 'okta-sub',
    OktaAccessToken = 'okta-access-token',
    LocalCurrency = 'localCurrency'
}
